export default {
  lineAt: '@vr1game', // Default value
  linkLine: 'https://lin.ee/tqR1wJD', // Default value
  defaultAdminContactLineLink: 'https://lin.ee/tqR1wJD',
  adminContactLineLink: 'https://lin.ee/tqR1wJD',
  domains: [],
  partnerReferralHost: 'vr1game-v2.club',
  isLoaded: false
}
